export const GovernmentBuilding = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 9.5L12.5 4L21.5 9.5M5.5 20H19.5M10.5 9H14.5M6.5 12L6.5 17M10.5 12L10.5 17M14.5 12V17M18.5 12V17"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
